"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordRequestEmailResultToJSON = exports.ForgotPasswordRequestEmailResultFromJSONTyped = exports.ForgotPasswordRequestEmailResultFromJSON = void 0;
var runtime_1 = require("../runtime");
function ForgotPasswordRequestEmailResultFromJSON(json) {
    return ForgotPasswordRequestEmailResultFromJSONTyped(json, false);
}
exports.ForgotPasswordRequestEmailResultFromJSON = ForgotPasswordRequestEmailResultFromJSON;
function ForgotPasswordRequestEmailResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
        'accountHasNoPassword': !(0, runtime_1.exists)(json, 'accountHasNoPassword') ? undefined : json['accountHasNoPassword'],
    };
}
exports.ForgotPasswordRequestEmailResultFromJSONTyped = ForgotPasswordRequestEmailResultFromJSONTyped;
function ForgotPasswordRequestEmailResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'message': value.message,
        'accountHasNoPassword': value.accountHasNoPassword,
    };
}
exports.ForgotPasswordRequestEmailResultToJSON = ForgotPasswordRequestEmailResultToJSON;
//# sourceMappingURL=ForgotPasswordRequestEmailResult.js.map